import { render } from "./ProteinSequence.vue?vue&type=template&id=966f741c"
import script from "./ProteinSequence.vue?vue&type=script&lang=js"
export * from "./ProteinSequence.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__